






import Enumerable from "linq";
import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { DocumentSummaryHistory } from "../../../domain/document";
import { ModelEditableMixin } from "../../system/mixins";
import { StandardOption } from "../../system/selectors/mixins";
import OptionDropDownSelector from "../../system/selectors/OptionDropDownSelector.vue";

@Component({
  components: {
    selector: OptionDropDownSelector,
  }
})
export default class DocumentArchiveSelector extends Mixins(ModelEditableMixin) {
  @Prop({ default: null })
  documentId: number;

  @Prop({ default: null })
  archiveId: number;

  @Emit()
  publishedHistoryUpdated(hasPublishedHistory: boolean): void {}

  data(): any {
    return {
      archives: null as DocumentSummaryHistory[],
    };
  }
  archives: DocumentSummaryHistory[];

  get isLoaded(): boolean {
    return !!this.archives;
  }

  get options(): StandardOption<DocumentSummaryHistory>[] {
    return !this.archives
      ? []
      : Enumerable.from(this.archives)
        .select(s => new StandardOption<DocumentSummaryHistory>("第" + s.edition + "版：" + (s.isDeleted ? "削除済" : s.isTemporary ? "一時保存" : "登録"), s))
        .toArray();
  }

  get maxEdition(): number {
    return Enumerable.from(this.archives)
      .max(e => e.edition);
  }

  get hasPublishedHistory(): boolean {
    return this.archives && this.archives.some(a => a.published);
  }

  created(): void {
    this.updateArchiveDocuments();
  }

  @Watch("documentId")
  onDocumentIdUpdated(newValue: number, oldValue: number): void {
    this.updateArchiveDocuments();
  }

  updateArchiveDocuments(selectedArchiveId: number = null): void {
    if (!this.documentId) {
      this.archives = [];
      this.editingSource = null;
      return;
    }
    this.archives = null;
    DomainRegistry.document.getDocumentRepository().getArchiveDocuments(this.documentId)
    .then(d => {
      this.archives = d;
      this.editingSource = this.toInitialModel(d, selectedArchiveId ? selectedArchiveId : this.archiveId);
      this.publishedHistoryUpdated(this.hasPublishedHistory);
    }).catch(e => {
      this.$error(
        "文書履歴取得失敗",
        "文書履歴を取得できませんでした。",
        e,
      );
      this.archives = [];
      this.publishedHistoryUpdated(false);
    });
  }

  private toInitialModel(source: DocumentSummaryHistory[], archiveId: number): DocumentSummaryHistory {
    return Enumerable.from(source)
      .firstOrDefault(e => (e.archiveId === archiveId) || (e.edition === this.maxEdition));
  }
}
